module.exports = __webpack_public_path__ + "static/media/xmy.605b8898.svg";